//引入自定义指令
import loadMore from '@/utils/loadmore'
import track from '@/directives/track'
import resize from "@/directives/sizeDirect.js"
import clipboard from "@/directives/clipboard.js"
const directives = {
 loadMore,
 track,
 resize,
 clipboard
}
export default {
    install(Vue) {
        Object.keys(directives).forEach((key) => {
            Vue.directive(key, directives[key])
            // console.log( directives[key])
        })
    },
}